import React from 'react';
import { styles } from './SpecialOffers.css';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { SpecialOffer as SpecialOfferType } from '../../PdpProductProvider/types';
import { SpecialOffer } from '../../SpecialOffer/SpecialOffer';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export type SpecialOffersProps = {
  offers: Array<SpecialOfferType>;
};

const SINGLE_OFFER_TEXT = "DON'T MISS OUT ON THIS!";
const MULTIPLE_OFFER_TEXT = "DON'T MISS OUT ON THESE!";

export const SpecialOffers = ({ offers }: SpecialOffersProps) => {
  const fullBleed = window.matchMedia('(max-width: 991.95px)').matches;

  return (
    <div className={styles.container}>
      {/* This span is for the anchor tag scroll to consider the extra height of header for desktops */}
      <span id="special-offers" className={styles.anchorTag}></span>
      <div className={styles.title}>
        <CalloutFont>{offers.length > 1 ? MULTIPLE_OFFER_TEXT : SINGLE_OFFER_TEXT}</CalloutFont>
      </div>
      {offers.length === 1 ? (
        <SpecialOffer offer={offers[0]} className={styles.singleOffer} />
      ) : (
        <Carousel
          className={styles.slider}
          slidesPerView={1.02}
          spaceBetween={10}
          freeMode={false}
          breakpoints={{ 768: { slidesPerView: 1.4 } }}
          fullBleed={fullBleed}
        >
          {offers.map(offer => {
            return <SpecialOffer className={styles.slideContent} key={offer.title} offer={offer} />;
          })}
        </Carousel>
      )}
    </div>
  );
};
